import Address from 'components/shared/Helpers/Address'
import React from 'react'
import { Divider, Grid, Header, Table } from 'semantic-ui-react'
import { I18n } from 'lib/i18n'

const i18nKey = 'checkout.'

class DealerCartHeader extends React.PureComponent {
  render() {
    const {
      delivery_date,
      haulage_info,
      orderer_name,
      payment_type,
      reference,
      self_pickup,
      shipping_address,
      shipping_address_matches,
      shipping_date,
      user,
    } = this.props

    const showDelivery = shipping_address && !shipping_address_matches
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={6}>
            <Header
              as="h4"
              children={`${I18n.t(i18nKey + 'billing_address')}:`}
              color="orange"
            />
            <Address postal data={user} />
            <Header as="h4" content={`Kundennummer: ${user.address_number}`}/>
          </Grid.Column>
          {showDelivery && (
            <Grid.Column width={6}>
              <Header
                as="h4"
                children={`${I18n.t(i18nKey + 'shipping_address')}:`}
                color="orange"
              />
              <Address postal data={shipping_address} />
            </Grid.Column>
          )}
        </Grid.Row>
        <Divider />
        <Grid.Row>
          <Grid.Column width={6}>
            <Table basic="very">
              <Table.Body>
                <Table.Row>
                  <Table.Cell
                    collapsing
                    children={`${I18n.t(i18nKey + 'payment.header')}:`}
                  />
                  <Table.Cell
                    children={I18n.t(i18nKey + 'payment.' + payment_type)}
                  />
                </Table.Row>

                {self_pickup && (
                  <Table.Row>
                    <Table.Cell
                      collapsing
                      children={`${I18n.t(i18nKey + 'delivery.pickup')}:`}
                    />
                    <Table.Cell
                      children={I18n.t(i18nKey + 'payment.' + self_pickup)}
                    />
                  </Table.Row>
                )}
                <Table.Row>
                  <Table.Cell
                    collapsing
                    children={`${I18n.t(i18nKey + 'shipping_date.title')}:`}
                  />
                  <Table.Cell
                    children={
                      shipping_date === 'custom'
                        ? delivery_date
                        : I18n.t(i18nKey + 'shipping_date.' + shipping_date)
                    }
                  />
                </Table.Row>

                {orderer_name && (
                  <Table.Row>
                    <Table.Cell
                      collapsing
                      children={`${I18n.t(i18nKey + 'purchaser_name')}:`}
                    />
                    <Table.Cell children={orderer_name} />
                  </Table.Row>
                )}
                {reference && (
                  <Table.Row>
                    <Table.Cell
                      collapsing
                      children={`${I18n.t(i18nKey + 'reference')}:`}
                    />
                    <Table.Cell children={reference} />
                  </Table.Row>
                )}
                {haulage_info && (
                  <Table.Row>
                    <Table.Cell
                      collapsing
                      children={`${I18n.t(i18nKey + 'haulage_info')}:`}
                    />
                    <Table.Cell children={haulage_info} />
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

export default DealerCartHeader



// WEBPACK FOOTER //
// ./src/components/admin/Carts/DealerCart/DealerCartHeader.jsx